import React, { useState } from "react";
import "../App.css";
import FiveGridChart from "../component/FiveGridChart/FiveGridChart";
import SecondFiveGridChart from "../component/SecondFIveGridChart/SecondFIveGridChart";
import prevs from "../images/prevs.svg";
import next from "../images/next.svg";
import Header from "../component/Header";

const ChartReportsPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [transitionDirection, setTransitionDirection] = useState(""); // Tracks the swipe direction

  const handlePageChange = (page) => {
    if (page !== currentPage) {
      setTransitionDirection(page > currentPage ? "slide-next" : "slide-prev");
      setTimeout(() => setCurrentPage(page), 500); // Delay matches the animation duration
    }
  };

  return (
    <div className="grid-main-container">
      <Header />
      <div className={`chart-container ${transitionDirection}`} onAnimationEnd={() => setTransitionDirection("")}>
        {currentPage === 1 && <FiveGridChart />}
        {currentPage === 2 && <SecondFiveGridChart />}
      </div>

      {/* Pagination Controls */}
      <div className="btn-container">
        <div
          onClick={() => handlePageChange(1)}
          style={{
            marginRight: "15px",
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
          }}
          className={`arrow left ${currentPage === 1 ? "disabled" : ""}`}
        >
          <img src={prevs} alt="Previous" />
        </div>
        <div
          onClick={() => handlePageChange(2)}
          style={{
            cursor: currentPage === 2 ? "not-allowed" : "pointer",
          }}
          className={`arrow right ${currentPage === 2 ? "disabled" : ""}`}
        >
          <img src={next} alt="Next" />
        </div>
      </div>
    </div>
  );
};

export default ChartReportsPage;
